import { css } from "../../../styled-system/css";

export const styles = {
  buttonWrapper: () =>
    css({
      width: "fit-content",
      marginTop: "baseUnit.mobile3",
      marginX: "auto",
      marginBottom: 0,
    }),

  noVisibleButtonWrapper: () =>
    css({
      width: "fit-content",
      margin: "0 auto",
    }),

  accessibleButton: () =>
    css({
      all: "inherit",
    }),

  inlineButton: () =>
    css({
      all: "unset",
      cursor: "pointer",
      color: "inherit",
      textDecoration: "inherit",
      textDecorationStyle: "inherit",
    }),
};
